// extracted by mini-css-extract-plugin
module.exports = {"tags":"styles_tags__1ZOvL","cards":"styles_cards__h0Auv","showMore":"styles_showMore__hynjC"};